import { FormikHelpers } from 'formik'
import React, { FC } from 'react'
import Form from '../../components/Form'
import CustomButton from '../../components/UI/Buttons/CustomButton'

interface CreateProjectStep4Props {
  goForward: () => void
}

const CreateProjectStep4: FC<CreateProjectStep4Props> = ({ goForward }) => {
  const setUpForm = {
    initialValues: { email: '', password: '' },
    validation: 'user',
    onSubmit: async (values: any, actions: FormikHelpers<any>) => {
      goForward()
      // await dispatch(signIn(values))
    }
  }

  return (
    <div className='agency-creation-step'>
      <div className='agency-creation-step__title'>Connect Social Accounts</div>
      <Form {...setUpForm}>
        <div className='agency-creation-step__buttons'>
          <CustomButton onClick={() => goForward()} button='primary' size='big' type='button'>
            Skip
          </CustomButton>
          <CustomButton button='primary' size='big' type='submit'>
            Submit
          </CustomButton>
        </div>
      </Form>
    </div>
  )
}

export default CreateProjectStep4
